import { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { authAPI } from '../utils/api';
import toast from 'react-hot-toast';
import './Auth.css';

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return toast.error('Dono passwords same honni chahiye');
    if (password.length < 6) return toast.error('Password min 6 characters');
    setLoading(true);
    try {
      await authAPI.resetPassword(token, password);
      toast.success('Password reset ho gaya! Login karo.');
      navigate('/login');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Error aaya ya token expire ho gaya');
    }
    setLoading(false);
  };

  return (
    <div className="auth-page page">
      <div className="container">
        <div className="auth-card card">
          <div className="auth-header">
            <h2>🔒 Naya Password Set Karo</h2>
          </div>
          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-group">
              <label>Naya Password</label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)}
                placeholder="Min 6 characters" className="form-input" required />
            </div>
            <div className="form-group">
              <label>Password Confirm Karo</label>
              <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)}
                placeholder="Same password dobara daalo" className="form-input" required />
            </div>
            <button type="submit" className="btn btn-primary btn-full" disabled={loading}>
              {loading ? 'Reset ho raha hai...' : 'Password Reset Karo'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
